exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".login__login___3M-XZ {\n  width: 80vw;\n  margin: 0 auto; }\n  .login__login___3M-XZ a {\n    text-decoration: none;\n    color: #A7A7A7;\n    font-weight: bold; }\n  .login__login___3M-XZ .login__logo___3rqYP {\n    display: flex;\n    justify-content: center; }\n  .login__login___3M-XZ .login__loginContent___PHK32 {\n    font-size: 20px;\n    text-align: center;\n    color: #A7A7A7; }\n    .login__login___3M-XZ .login__loginContent___PHK32 h2 {\n      font-weight: normal;\n      font-size: 45px;\n      margin: 0; }\n    .login__login___3M-XZ .login__loginContent___PHK32 p {\n      margin: 15px 0; }\n    .login__login___3M-XZ .login__loginContent___PHK32 button {\n      margin-left: 10px; }\n  .login__login___3M-XZ .login__loginContentForm___3M_pb {\n    margin-top: 30px; }\n", ""]);

// exports
exports.locals = {
	"login": "login__login___3M-XZ",
	"logo": "login__logo___3rqYP",
	"loginContent": "login__loginContent___PHK32",
	"loginContentForm": "login__loginContentForm___3M_pb"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/containers/Login/login.scss
// module id = 656
// module chunks = 0